import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean } from '@storybook/addon-knobs';


const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Checkbox 3-stavový', () => ({
		template: '<dms-3state-check v-bind="$props" :value.sync="value" />',
		data() {
			return {
				value: null,
			};
		},
		props: {
			label: {
				default: text('Label', 'Souhlasím'),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
	}));
